import images from "@assets/images";
import { DimensionContext } from "@src/DimensionProvider";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedAvatarTier } from "@src/ducks/slices/lobby.slice";
import { ImageButton06 } from "components/button";
import SprinkerStar from "components/sprinkler-star";
import React, { useContext } from "react";
import { Image, View } from "react-native";
import { AvatarContext } from "../AvatarProvider";
import useStyles from "./styles.css";

const Tier = () => {
  const styles = useStyles();
  const tier = useAppSelector(selectedAvatarTier);
  const { setShowScreen } = useContext(AvatarContext);
  const { baseWidth, baseHeight } = React.useContext(DimensionContext);
  const tierLabel = React.useMemo(() => {
    switch(tier.tierID){
    case 1:
      return images["t-copper"];
    case 2:
      return images["t-bronze"];
    case 3:
      return images["t-silver"];
    case 4:
      return images["t-gold"];
    default:
      return images["t-copper"];
    }
  },[tier.tierID]);


  return (
    <View style={styles.v_container}>
      <ImageButton06
        style={[
          styles.i_yourtier,
          { width: baseWidth * 0.1841, height: baseHeight * 0.259},
        ]}
        source={images.your_tier}
        labelStyle={{fontSize: baseWidth * 0.023, marginTop: "10%"}}
      />
      <View
        style={[
          styles.v_tiercenter,
          { width: baseWidth * 0.21, height: baseWidth * 0.24 },
        ]}
      >
        <Image
          style={styles.i_tierlevel}
          source={tier.tierAvatar}
          resizeMode="cover"
          resizeMethod="scale"
        />
        <SprinkerStar WIDTH={baseWidth * 0.2774} HEIGHT={baseWidth * 0.25} />
      </View>
      <Image
        style={{ bottom: "2%", width: baseWidth * 0.1, height: baseWidth * 0.035 }}
        source={{ uri: tierLabel }}
        resizeMode="stretch"
      />
      <ImageButton06
        onPress={() => setShowScreen("tier")}
        style={[
          styles.btn_tier,
          { height: baseWidth * 0.05, width: baseWidth * 0.15 },
        ]}
        label="НАГРАДИ ЗА НИВО"
        source={images["btn-big"]}
        labelStyle={{fontSize: baseWidth * 0.012}}
      />
    </View>
  );
};

export default Tier;
